import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  :root {
    --tws-cream: #FAF7F2;
    --tws-brown: #8B6F5E;
    --tws-gold: #D4A853;
    --tws-dark: #2C2416;
    --tws-white: #FFFFFF;
    --tws-muted: #F0EDE6;
    --tws-border: #E8E3DA;
    --tws-danger: #C44D4D;
    --tws-success: #6B8E7B;
    --tws-text-muted: #8E8B82;
    --tws-font-heading: 'Red Hat Display', sans-serif;
    --tws-font-body: 'Red Hat Text', sans-serif;
    --tws-radius-sm: 8px;
    --tws-radius-md: 12px;
    --tws-radius-lg: 16px;
    --tws-radius-pill: 50rem;
    --tws-shadow-sm: 0 1px 3px rgba(44, 36, 22, 0.06);
    --tws-shadow-md: 0 4px 12px rgba(44, 36, 22, 0.08);
    --tws-shadow-lg: 0 8px 24px rgba(44, 36, 22, 0.10);
    --tws-transition: all 0.2s ease;

    --bs-body-bg: var(--tws-cream);
    --bs-body-color: var(--tws-dark);
    --bs-font-sans-serif: var(--tws-font-body);
    --bs-border-radius: var(--tws-radius-md);
    --bs-border-radius-lg: var(--tws-radius-lg);
    --bs-border-radius-sm: var(--tws-radius-sm);
    --bs-border-radius-pill: var(--tws-radius-pill);
    --bs-link-color: var(--tws-brown);
    --bs-link-hover-color: var(--tws-dark);
    --bs-primary: var(--tws-gold);
    --bs-primary-rgb: 212, 168, 83;
    --bs-success: var(--tws-success);
    --bs-success-rgb: 107, 142, 123;
    --bs-danger: var(--tws-danger);
    --bs-danger-rgb: 196, 77, 77;
    --bs-dark: var(--tws-dark);
    --bs-dark-rgb: 44, 36, 22;
    --bs-light: var(--tws-white);
    --bs-light-rgb: 255, 255, 255;
    --bs-secondary: var(--tws-brown);
    --bs-secondary-rgb: 139, 111, 94;
  }

  [data-theme="dark"] {
    --tws-cream: #1C1916;
    --tws-brown: #B89B8A;
    --tws-gold: #D4A853;
    --tws-dark: #EBE5DC;
    --tws-white: #262320;
    --tws-muted: #2D2A26;
    --tws-border: #3D3934;
    --tws-danger: #D47272;
    --tws-success: #7D9E8B;
    --tws-text-muted: #8E8A84;
    --tws-shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.2);
    --tws-shadow-md: 0 4px 12px rgba(0, 0, 0, 0.3);
    --tws-shadow-lg: 0 8px 24px rgba(0, 0, 0, 0.35);

    --bs-body-bg: var(--tws-cream);
    --bs-body-color: var(--tws-dark);
    --bs-link-color: var(--tws-brown);
    --bs-link-hover-color: #D4C8B8;
    --bs-dark: #EBE5DC;
    --bs-dark-rgb: 235, 229, 220;
    --bs-light: #262320;
    --bs-light-rgb: 38, 35, 32;
    --bs-secondary: var(--tws-brown);
    --bs-secondary-rgb: 184, 155, 138;
    --bs-secondary-color: #9E9A94;
    --bs-border-color: var(--tws-border);
  }

  [data-theme="dark"] .bg-light {
    background-color: var(--tws-white) !important;
  }

  [data-theme="dark"] .bg-white {
    background-color: var(--tws-white) !important;
  }

  [data-theme="dark"] .text-dark {
    color: var(--tws-dark) !important;
  }

  [data-theme="dark"] .text-muted {
    color: #9E9A94 !important;
  }

  [data-theme="dark"] .badge.bg-dark {
    background-color: var(--tws-dark) !important;
    color: var(--tws-cream) !important;
  }

  [data-theme="dark"] .shop-logo,
  [data-theme="dark"] .cat-img,
  [data-theme="dark"] .loading-logo {
    filter: invert(1);
  }

  [data-theme="dark"] .react-datepicker {
    background-color: var(--tws-white);
    border-color: var(--tws-border);
    color: var(--tws-dark);
  }

  [data-theme="dark"] .react-datepicker__header {
    background-color: var(--tws-muted);
    border-bottom-color: var(--tws-border);
  }

  [data-theme="dark"] .react-datepicker__day,
  [data-theme="dark"] .react-datepicker__day-name,
  [data-theme="dark"] .react-datepicker__current-month {
    color: var(--tws-dark);
  }

  [data-theme="dark"] .react-datepicker__day:hover {
    background-color: var(--tws-brown);
    color: #fff;
  }

  [data-theme="dark"] .react-datepicker__day--selected,
  [data-theme="dark"] .react-datepicker__day--keyboard-selected {
    background-color: var(--tws-brown);
    color: #fff;
  }

  [data-theme="dark"] .react-datepicker__day--disabled {
    color: var(--tws-text-muted);
  }

  [data-theme="dark"] .react-datepicker__time-container {
    border-left-color: var(--tws-border);
  }

  [data-theme="dark"] .react-datepicker__time-box {
    background-color: var(--tws-white);
  }

  [data-theme="dark"] .react-datepicker__time-list-item {
    color: var(--tws-dark);
  }

  [data-theme="dark"] .react-datepicker__time-list-item:hover {
    background-color: var(--tws-brown) !important;
    color: #fff !important;
  }

  [data-theme="dark"] .btn-dark {
    background-color: var(--tws-gold) !important;
    border-color: var(--tws-gold) !important;
    color: #1C1916 !important;
  }

  [data-theme="dark"] .btn-dark:hover,
  [data-theme="dark"] .btn-dark:focus,
  [data-theme="dark"] .btn-dark:active {
    background-color: #c99d3f !important;
    border-color: #c99d3f !important;
  }

  [data-theme="dark"] .btn-outline-dark {
    border-color: var(--tws-dark);
    color: var(--tws-dark);
  }

  [data-theme="dark"] .btn-outline-dark:hover,
  [data-theme="dark"] .btn-outline-dark:focus,
  [data-theme="dark"] .btn-outline-dark:active {
    background-color: var(--tws-dark) !important;
    border-color: var(--tws-dark) !important;
    color: var(--tws-cream) !important;
  }

  [data-theme="dark"] .btn-outline-secondary {
    border-color: #5A5450;
    color: var(--tws-dark);
  }

  [data-theme="dark"] .btn-outline-secondary:hover,
  [data-theme="dark"] .btn-outline-secondary:focus,
  [data-theme="dark"] .btn-outline-secondary:active {
    background-color: var(--tws-muted) !important;
    border-color: #7A736E !important;
  }

  [data-theme="dark"] .card {
    background: var(--tws-white);
  }

  [data-theme="dark"] .modal-content {
    background: var(--tws-white);
    color: var(--tws-dark);
  }

  [data-theme="dark"] .form-control,
  [data-theme="dark"] .form-select {
    background: var(--tws-white);
    color: var(--tws-dark);
    border-color: var(--tws-border);
  }

  [data-theme="dark"] .table {
    --bs-table-bg: var(--tws-white);
    --bs-table-color: var(--tws-dark);
    --bs-table-striped-bg: var(--tws-muted);
    --bs-table-striped-color: var(--tws-dark);
    --bs-table-hover-bg: var(--tws-muted);
    --bs-table-border-color: var(--tws-border);
  }

  [data-theme="dark"] .border-success {
    --bs-border-color: var(--tws-success);
  }

  @media (min-width: 768px) {
    body {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    #root {
      width: 100%;
      max-width: 1200px;
    }
  }
`;
